module.exports = __webpack_public_path__ + "img/svg6.7f515fb3.svg";